import React, { useState } from 'react';
import styled from 'styled-components';
import { Window } from '../Window/Window';

const DialogContent = styled.div`
  padding: 16px;
  background: #c0c0c0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
`;

const Input = styled.input`
  padding: 4px;
  width: 100%;
  font-family: 'MS Sans Serif', sans-serif;
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

const Button = styled.button`
  padding: 4px 16px;
  background: #c0c0c0;
  border: 2px solid;
  border-color: #ffffff #808080 #808080 #ffffff;
  &:active {
    border-color: #808080 #ffffff #ffffff #808080;
  }
`;

export const SaveDialog = ({ onClose, onSave, isActive, onActivate }) => {
  const [filename, setFilename] = useState('');

  const handleSave = () => {
    if (filename) {
      onSave(filename.endsWith('.txt') ? filename : `${filename}.txt`);
      onClose();
    }
  };

  return (
    <Window
      title="Save As"
      onClose={onClose}
      isActive={isActive}
      onActivate={onActivate}
      defaultWidth="300px"
      defaultHeight="150px"
    >
      <DialogContent>
        <div>
          <label>File name:</label>
          <Input
            type="text"
            value={filename}
            onChange={(e) => setFilename(e.target.value)}
            placeholder="filename.txt"
            autoFocus
          />
        </div>
        <ButtonRow>
          <Button onClick={handleSave}>Save</Button>
          <Button onClick={onClose}>Cancel</Button>
        </ButtonRow>
      </DialogContent>
    </Window>
  );
}; 